/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMoeSingleImageData } from './moe-single-image.data';
import { IMoeSingleImageProps } from './moe-single-image.props.autogenerated';

export interface IMoeSingleImageViewProps extends IMoeSingleImageProps<IMoeSingleImageData> {}

/**
 *
 * MoeSingleImage component
 * @extends {React.PureComponent<IMoeSingleImageProps<IMoeSingleImageData>>}
 */
class MoeSingleImage extends React.PureComponent<IMoeSingleImageProps<IMoeSingleImageData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default MoeSingleImage;
